var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeadlineContainer',{attrs:{"headline":"Legal Texts","breadcrumbs":[{text: 'Legal Texts'}]}},[_c('router-link',{staticClass:"btn btn-white",attrs:{"to":"/legal-texts/create"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Create\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('LegalTextList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }